import { AxDropdown, AxFormValidation } from "@axess/limestone";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { MeasurementHelper } from "../../Lib/Helper/MeasurementHelper";
import { PriceHelper } from "../../Lib/Helper/PriceHelper";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { ProductTripleWithType } from "../../Models/Products/ProductTripleWithType";
import { CustomerLessonProperties, LessonProperty } from "../Account/CustomerLessonProperties";

interface ILessonPersonalizationInitData {
    datepickerFormat: string;
    datepickerLanguage: string;
    datepickerWeekStart: number;
    dto: LessonAddToCartDto;
}

class LessonAddToCartDto {
    lessonNr: number;
    lessonWebNr: number;
    lessonArcNr: number;
    lessonDefNr: number;
    lessonAddToCartProducts: LessonAddToCartProducts[] = [];
}

class LessonAddToCartProducts extends ProductTripleWithType {
    subTypeIdentifier: number;
    person: LessonAddToCartPerson;
    additions: LessonAddToCartProductAddition[] = [];
}

class LessonAddToCartProductAddition {
    packagePositionNr: number;
}

class LessonAddToCartPerson {
    accountId: number;

    firstName: string;
    lastName: string;
    dateOfBirth: string;

    gender?: string;
    height?: string | null;
    weight?: string | null;
    shoeSize?: string | null;
    lessonAllergies?: LessonProperty[] = [];
    lessonLanguages?: LessonProperty[] = [];
    lessonMedicals?: LessonProperty[] = [];
    lessonLevels?: LessonProperty[] = [];

    emergencyName?: string | null;
    emergencyEmail?: string | null;
    emergencyPhone?: string | null;
    instructor?: string | null;
    goal?: string | null;
}


@ModuleName("LessonsPersonalization")
export class LessonPersonalization implements AxInit {
    private initData: ILessonPersonalizationInitData;
    private personDropDown = new AxDropdown();
    private levelDropDown = new AxDropdown();
    private weightDropDown: AxDropdown = new AxDropdown();
    private heightDropDown: AxDropdown = new AxDropdown();
    private showSizeDropDown: AxDropdown = new AxDropdown();
    private measurementHelper: MeasurementHelper = new MeasurementHelper();

    private propertyModules: CustomerLessonProperties[][] = [];

    constructor(private _priceHelper = new PriceHelper(null, true),
        private _requestHelper = new RequestHelper(),
        private _axLoading = new AxLoading(),
        private _i18nHelper = new I18nHelper(),) {

    }

    AxInit(init?: ILessonPersonalizationInitData): void {
        this.initData = init as ILessonPersonalizationInitData;

        $('[data-lesson="personalization-person-btn"]').on('click', (e) => {
            const $button = $(e.delegateTarget);
            this.toggleActivePerson($button);
        });

        $('[data-lesson="personalization-person-wrapper"]').on('change', '[data-lesson="unit-system"]', (e) => {
            const $radio = $(e.currentTarget);
            const selectedUnit = $radio.val() as number;
            const originalUnit = selectedUnit == UnitSystemEnum.Imperial ? UnitSystemEnum.Metric : UnitSystemEnum.Imperial;
            const index = parseInt($radio.attr('data-index') as string);
            const $target = $(`[data-lesson="personalization-person-form"][data-index="${index}"]`)

            const shoeSize = $target.find(`input[name="ParticipantInfos[${index}].ShoeSize"]`).val() as string;
            let weight = $target.find(`input[name="ParticipantInfos[${index}].Weight"]`).val() as string;
            let height = $target.find(`input[name="height-${index}"]`).val() as string;
            if (originalUnit == UnitSystemEnum.Imperial) {
                const heightFeet = Number($target.find(`input[name="heightFeet-${index}"]`).val() as string);
                const heightInch =  Number($target.find(`input[name="heightInch-${index}"]`).val() as string);
                const totalInches = this.measurementHelper.feetAndInchesToTotalInches(heightFeet, heightInch);
                weight = this.measurementHelper.lbsToKg(Number(weight as string)).toString()
                height = this.measurementHelper.inchesToMeters(totalInches).toString();
            }

            AxessViewer.loadPartialView('/Products/Lessons/GetAccRentalInfo', {
                unit: selectedUnit,
                index: index,
                rentalViewModel: {
                    height: height,
                    weight: weight,
                    shoeSize: shoeSize,
                }
            }, (resp) => {
                $('[data-lesson="personalization-rental"]').html(resp.view);
                this.initRentDropdowns();
            });
        });

        this.initCustomerProps();
        this.initPersonDropDown();
        this.initDatePicker();
        this.updatePriceSummary();
        this.initRentDropdowns();
        this.initFormValidation();
    }

    initFormValidation() {
        for (let form of $('[data-lesson="personalization-person-content"]')) {
            const index = parseInt($(form).attr('data-index') as string);

            const formValidator = new AxFormValidation({
                selector: `[data-lesson="personalization-person-form"][data-index="${index}"]`,
                rules: {},
                callback: (form: HTMLElement) => {
                    const $currentButton = $(`[data-lesson="personalization-person-btn"][data-index=${index}]`);
                    $currentButton.find('i').removeClass('d-none');

                    if ($(form).is('[data-lesson-personalization="next"]')) {
                        const nextIndex = index + 1;
                        const $button = $(`[data-lesson="personalization-person-btn"][data-index=${nextIndex}]`);
                        this.toggleActivePerson($button);
                    } else {
                        this.submit();
                    }
                }
            }).init();

            this.applyRules(index);
        }
    }

    initCustomerProps() {
        let index = 0;
        for (const personWrapper of $('[data-lesson="personalization-person-wrapper"]')) {
            const $personWrapper = $(personWrapper);
            const target = $personWrapper.attr('data-target') as string;

            const customerLessonProps = new CustomerLessonProperties();
            customerLessonProps.AxInit({
                parentId: `[data-lesson="personalization-person-wrapper"][data-target="${$personWrapper.attr('data-target')}"]`,
                formElementPrefix: `ParticipantInfos[${index}].`
            });

            this.propertyModules[target] = customerLessonProps;
            index++;

            $personWrapper.on('change', '[data-lesson="personalization-addProduct"]', (e) => {
                const $orgTarget = $(e.delegateTarget);
                const target = $orgTarget.attr('data-target');

                const $checkbox = $(e.currentTarget);
                const isChecked = $checkbox.prop('checked');
                const pos = $checkbox.val();

                $(`[data-lesson-summary="opt-item"][data-target="${target}"][data-value="${pos}"]`)
                    .toggleClass('d-none', !isChecked)
                    .toggleClass('d-flex', isChecked)
                    .attr('data-active', isChecked ? "true" : "false");
                this.updatePriceSummary();
            });
        }

        this.levelDropDown.init(`[data-lesson="personalization-level-drpdwn"]`, {
            searchBar: false,
            multiSelect: false,
        });
    }

    initDatePicker() {
        $('[data-lesson="personalization-person-dob"]').datepicker({
            format: this.initData.datepickerFormat,
            language: this.initData.datepickerLanguage,
            weekStart: this.initData.datepickerWeekStart
        });
    }

    initPersonDropDown() {
        this.personDropDown = new AxDropdown();

        this.personDropDown.init(`[data-lesson="personalization-person-drpdwn"]`, {
            searchBar: false,
            multiSelect: false,
            onSelect: ($elem: JQuery<HTMLElement>, value) => {
                const accountId = parseInt(value.toString());
                const index = parseInt($elem.attr('data-index') as string);
                const target = $elem.attr('data-target') as string;
                const subTypeIdentifier = $elem.attr('data-identifier') as string;

                this.loadPerson(index, accountId, target, subTypeIdentifier);
            }
        });
    }

    loadPerson(index: number, accountId: number, target: string, subTypeIdentifier: string, unitInt?: number) {
        const $target = $(`[data-lesson="personalization-person-content"][data-index="${index}"]`);

        this._axLoading.ShowLoadingIndicator($target[0], false)

        AxessViewer.loadPartialView('/Products/Lessons/PersonalizationPartial', {
            r: this._requestHelper.findGetParameter('r'),
            customerAccountNr: accountId,
            index: index,
            subTypeIdentifier: subTypeIdentifier,
            unitInt: unitInt
        }, (resp) => {
            this._axLoading.HideLoadingIndicator($target[0]);

            $target.html(resp.returnView);
            this.initCustomerProps();
            this.initRentDropdowns();
            this.initDatePicker();

            for (let optionalItem of $(`[data-lesson="summary-accordion"] [data-lesson-summary="opt-item"][data-target="${target}"]`)) {
                const $optionalItem = $(optionalItem);
                const value = $optionalItem.attr('data-value');
                const active = (/true/).test($optionalItem.attr('data-active') as string);

                $target.find(`[data-lesson="personalization-addProduct"][value="${value}"]`).prop('checked', active);
            }
            this.updatePriceSummary();
        });
    }

    toggleActivePerson($button: JQuery<HTMLElement>) {
        const target = $button.attr('data-target');

        $('[data-lesson="personalization-person-btn"]').removeClass('ax-btn-primary').addClass('ax-btn-secondary');
        $button.addClass('ax-btn-primary').removeClass('ax-btn-secondary');

        $('[data-lesson="personalization-person-wrapper"]').removeClass('d-flex ').addClass('d-none');
        $(`[data-lesson="personalization-person-wrapper"][data-target="${target}"]`).addClass('d-flex ').removeClass('d-none');
    }

    updatePriceSummary() {
        const $priceHolder = $('[data-lesson-summary="price"]');
        const basePrice = parseInt($priceHolder.attr('data-tariff') as string);
        let newPrice = basePrice;

        for (let optionalItem of $('[data-lesson="summary-accordion"] [data-lesson-summary="opt-item"][data-active="true"]')) {
            const $optionalItem = $(optionalItem);
            const itemPrice = parseInt($optionalItem.attr('data-tariff') as string);

            newPrice += itemPrice;
        }

        $priceHolder.html(this._priceHelper.GetPriceStringWithCurrencySymbol(newPrice / 100));
    }

    submit() {
        let index = 0;
        const selectedUnit = $('input[data-lesson="unit-system"]:checked').val() as number;

        for (let product of this.initData.dto.lessonAddToCartProducts) {
            const productIdentifier = `${product.projNr}/${product.productGroupIdentifier}/${product.id}/${product.subTypeIdentifier}/${index}`;

            const $target = $(`[data-lesson="personalization-person-wrapper"][data-target="${productIdentifier}"]`);
            const $personDropdown = $target.find('[data-lesson="personalization-person-drpdwn"]');

            const customerAccountNr = parseInt((this.personDropDown.getValue($personDropdown) as string));

            const firstName = $target.find(`input[name="ParticipantInfos[${index}].FirstName"]`).val();
            const lastName = $target.find(`input[name="ParticipantInfos[${index}].LastName"]`).val();
            const dob = $target.find(`input[name="ParticipantInfos[${index}].DateOfBirth"]`).val();

            const shoeSize = $target.find(`input[name="ParticipantInfos[${index}].ShoeSize"]`).val() as string;
            let weight = $target.find(`input[name="ParticipantInfos[${index}].Weight"]`).val() as string;
            const $height = $target.find(`input[name="height-${index}"]`).length > 0
                ? $target.find(`input[name="height-${index}"]`)
                : $target.find(`input[name="ParticipantInfos[${index}].Height"]`)
            let height = $height.val() as string;
            if (!height && selectedUnit == UnitSystemEnum.Imperial) {
                const heightFeet = Number($target.find(`input[name="heightFeet-${index}"]`).val() as string);
                const heightInch =  Number($target.find(`input[name="heightInch-${index}"]`).val() as string);
                const totalInches = this.measurementHelper.feetAndInchesToTotalInches(heightFeet, heightInch);
                weight = this.measurementHelper.lbsToKg(Number(weight as string)).toString()
                height = this.measurementHelper.inchesToMeters(totalInches).toString();
            }

            const emergencyName = $target.find(`input[name="ParticipantInfos[${index}].EmergencyName"]`).val() as string;
            const emergencyEmail = $target.find(`input[name="ParticipantInfos[${index}].EmergencyEmail"]`).val() as string;
            const emergencyPhone = $target.find(`input[name="ParticipantInfos[${index}].EmergencyPhone"]`).val() as string;
            const instructor = $target.find(`input[name="ParticipantInfos[${index}].Instructor"]`).val() as string;
            const goal = $target.find(`input[name="ParticipantInfos[${index}].Goal"]`).html() as string;

            const propertyModule: CustomerLessonProperties = this.propertyModules[productIdentifier];

            product.person = {
                accountId: customerAccountNr,
                firstName: firstName as string,
                lastName: lastName as string,
                dateOfBirth: dob as string,
                height: height,
                weight: weight,
                shoeSize: shoeSize,
                lessonAllergies: propertyModule.allergies,
                lessonLanguages: propertyModule.languages,
                lessonLevels: propertyModule.lessonLevels,
                lessonMedicals: propertyModule.medicalStates,

                emergencyName: emergencyName,
                emergencyEmail: emergencyEmail,
                emergencyPhone: emergencyPhone,
                instructor: instructor,
                goal: goal,
            };

            const addProducts = $target.find('[data-lesson="personalization-addProduct"]:checked');
            product.additions = [];
            for (let addProd of addProducts) {
                product.additions.push({
                    packagePositionNr: parseInt($(addProd).attr('value') as string),
                });
            }
            index++;
        }

        const $submitButton = $('[data-lesson="personalization-submit"]');

        this._axLoading.ShowLoadingIndicatorButtonPrimary($submitButton[$submitButton.length - 1]);
        AxessViewer.loadPartialView('/Products/Lessons/AddToCart', {
            model: this.initData.dto,
        }, (resp) => {
            this._axLoading.HideLoadingIndicator($submitButton[$submitButton.length - 1]);
            AxLoad.LoadModule('AxFireShoppingCartModal', {
                result: resp,
                continueShoppingPath: 'Lessons',
                btn: '.lessons_add_to_cart_form',
                ResetQuantity: undefined,
            });
        }, {
            silent: true,
            skipShoppingCartReload: false,
        });
    }


    applyRules(index: number) {
        const $firstname = $(`#ParticipantInfos_${index}__Emergency_Email`);
        $firstname.rules('add', {
            required: true,
            email: true,
            regex: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i,
            messages: {
                email: this._i18nHelper.GetTranslation(Translations.I18NextMsgEmail),
                regex: this._i18nHelper.GetTranslation(Translations.I18NextMsgEmail),
            }
        });
    }

    initRentDropdowns() {
        this.weightDropDown.init(`.prod_selection__weight-selection`, {
            searchBar: false,
            multiSelect: false,
        });

        this.heightDropDown.init(`.prod_selection__height-selection`, {
            searchBar: false,
            multiSelect: false,
        });

        this.showSizeDropDown.init(`.prod_selection__shoeSize-selection`, {
            searchBar: false,
            multiSelect: false,
        });
    }
}

enum UnitSystemEnum {
    Metric = 0,
    Imperial = 1
}